import { render, staticRenderFns } from "./DictionaryFormOfCredits.vue?vue&type=template&id=5934d18c&scoped=true&"
import script from "./DictionaryFormOfCredits.vue?vue&type=script&lang=js&"
export * from "./DictionaryFormOfCredits.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryFormOfCredits.vue?vue&type=style&index=0&id=5934d18c&scoped=true&lang=scss&"
import style1 from "./DictionaryFormOfCredits.vue?vue&type=style&index=1&id=5934d18c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5934d18c",
  null
  
)

export default component.exports